










































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import { isValidHttpUrl } from '../service-for-algorithms/algorithms-1-is-valid-http-url'
import { replaceUrlWithHtmlUrl } from '../service-for-algorithms/algorithms-2-replace-url-with-html-url'


import DigitalCurrency20AnimatedCurrencyLabel from '../../basic-type-2-digital-currency/digital-currency-20-animated-currency-label.vue'

@Component({
  components: {
    DigitalCurrency20AnimatedCurrencyLabel
  }
})
class FolderItemView1DescriptionListView extends Vue {
  @Prop({ default: () => [] }) descriptionList?: any

  isValidHttpUrl = isValidHttpUrl

  updatePropertyValue (propertyValue: any) {
    propertyValue = replaceUrlWithHtmlUrl(propertyValue)
    return propertyValue
  }

  isArray (value: any) {
    return Array.isArray(value)
  }
}

export default FolderItemView1DescriptionListView

